// plugins/primevue-lucide.ts
import { defineNuxtPlugin } from '#app'
import { lucideVueIcons } from '~/utils/lucide-vue-icons';
import type { LucideIconName } from '@/utils/lucide-vue-icons';
import type { PropType } from 'vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('LucideNodeIcon', {
    props: {
      icon: {
        type: String as PropType<LucideIconName>,
        required: false
      }
    },
    setup(props: { icon?: LucideIconName }) {
      return () => (props.icon ? h(lucideVueIcons[props.icon], { class: 'w-4 h-4' }) : null)
    }
  })
})


